import React, { useState, useEffect } from "react";
import { ArrowForward, ChatBubbleOutline, Download, Home as HomeIcon, MiscellaneousServices, Campaign } from "@mui/icons-material"
import { Button, Modal, Box, Typography, Paper, Grid, Chip, Avatar, IconButton, Fade } from "@mui/material"
import { Swiper, SwiperSlide } from "swiper/react";
import { isMobile, isTablet, isDesktop } from 'react-device-detect';
import { Pagination, Navigation, Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./../Utils/styles.css"
import { testimonialsarray } from "../Utils/testimonials";
import { primarycolor } from "../Utils/colors";
import { useNavigate } from "react-router-dom";
import { getsessionuser } from "../Utils/sessions";
import SignIn from "../Common/login";
import { Postsitevisiturl } from "../Utils/urls";
import getBrowserFingerprint from 'get-browser-fingerprint';
import axios from "axios";
import { FaBed, FaShoppingBag, FaBullhorn, FaStar, FaGooglePlay } from "react-icons/fa";

const BRAND = "#900f20";
const BRAND_DARK = "#670600";

const Home = ({ onrefresh }) => {
    const fingerprint = getBrowserFingerprint();
    const navigate = useNavigate();
    const user = getsessionuser();
    const [showloginpopup, setshowloginpopup] = useState(false);
    const [showloginpopup2, setshowloginpopup2] = useState(false);

    const downloadapp = () => {
        window.open("https://play.google.com/store/apps/details?id=com.eazistey.eazistey", "_blank");
    }

    useEffect(() => {
        recordsitevisit();
    }, []);

    const recordsitevisit = () => {
        axios.post(Postsitevisiturl, { fingerprint: fingerprint, platform: "desktop" });
    }

    const onsuccesslogin = () => {
        onrefresh();
        navigate('/nav/chats', { state: { message: "startchart" } });
    }

    const onsuccesslogin2 = () => {
        onrefresh();
        navigate('/nav/myproperties', { state: { message: "addproperty" } });
    }

    const gotomyproperties = () => {
        user
            ? navigate('/nav/myproperties', { state: { message: "addproperty" } })
            : setshowloginpopup2(true);
    }

    const features = [
        {
            icon: <FaBed size={28} />,
            title: "Eazihomes",
            description: "Discover verified student hostels near your campus — complete with photos, facilities, pinned locations, and pricing.",
            cta: "Browse Hostels",
            action: () => navigate("/nav/hostels"),
            image: require("./../../assets/landing/home3.png"),
        },
        {
            icon: <FaShoppingBag size={28} />,
            title: "Eaziserve",
            description: "Find service providers around any university — from laundry to tutors. Browse contacts and book with ease.",
            cta: "Find Services",
            action: () => navigate("/nav/services"),
            image: require("./../../assets/landing/home8.png"),
        },
        {
            icon: <FaBullhorn size={28} />,
            title: "Advertise",
            description: "List your hostel or business and reach thousands of campus students actively searching every day.",
            cta: "Add Listing",
            action: gotomyproperties,
            image: require("./../../assets/landing/home2.png"),
        },
    ];

    const stats = [
        { value: "5,000+", label: "Students Helped" },
        { value: "300+", label: "Verified Hostels" },
        { value: "50+", label: "Service Providers" },
        { value: "4.8★", label: "Average Rating" },
    ];

    return (
        <Box sx={{ bgcolor: "#f8f9fa", minHeight: "100vh", fontFamily: "'Roboto', sans-serif", overflow: "hidden" }}>
            {/* Modals */}
            <Modal open={showloginpopup} onClose={() => setshowloginpopup(false)}>
                <SignIn onsuccesslogin={onsuccesslogin} />
            </Modal>
            <Modal open={showloginpopup2} onClose={() => setshowloginpopup2(false)}>
                <SignIn onsuccesslogin={onsuccesslogin2} />
            </Modal>

            {/* ═══ HERO SECTION ═══ */}
            <Box
                sx={{
                    position: "relative",
                    minHeight: { xs: "auto", md: "92vh" },
                    display: "flex",
                    alignItems: "center",
                    overflow: "hidden",
                    background: `linear-gradient(135deg, #0d0d0d 0%, #1a0005 40%, ${BRAND_DARK} 100%)`,
                }}
            >
                {/* Background Pattern */}
                <Box sx={{
                    position: "absolute", inset: 0, opacity: 0.04,
                    backgroundImage: "radial-gradient(circle at 1px 1px, white 1px, transparent 0)",
                    backgroundSize: "40px 40px"
                }} />
                {/* Glowing orbs */}
                <Box sx={{ position: "absolute", width: 600, height: 600, borderRadius: "50%", top: "-20%", right: "-10%", background: `radial-gradient(circle, ${BRAND}88 0%, transparent 70%)`, filter: "blur(60px)" }} />
                <Box sx={{ position: "absolute", width: 400, height: 400, borderRadius: "50%", bottom: "-10%", left: "5%", background: `radial-gradient(circle, ${BRAND_DARK}66 0%, transparent 70%)`, filter: "blur(80px)" }} />

                <Box sx={{ position: "relative", zIndex: 2, px: { xs: 3, md: 8 }, py: { xs: 8, md: 0 }, width: "100%", display: "flex", flexDirection: { xs: "column", md: "row" }, alignItems: "center", gap: 6 }}>
                    {/* Hero Left */}
                    <Box sx={{ flex: 1, maxWidth: { md: "55%" } }}>
                        <Chip
                            label="🏠 For Campus Students"
                            size="small"
                            sx={{ bgcolor: "rgba(255,255,255,0.08)", color: "rgba(255,255,255,0.7)", fontWeight: 600, mb: 4, backdropFilter: "blur(10px)", border: "1px solid rgba(255,255,255,0.1)" }}
                        />
                        <Typography
                            variant="h2"
                            sx={{ fontWeight: 900, color: "white", letterSpacing: "-1.5px", lineHeight: 1.1, mb: 3, fontSize: { xs: "2.5rem", md: "3.8rem" } }}
                        >
                            Your Campus<br />
                            <Box component="span" sx={{ background: `linear-gradient(90deg, ${BRAND} 0%, #ff6b6b 100%)`, WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>
                                Life, Simplified.
                            </Box>
                        </Typography>
                        <Typography variant="h6" sx={{ color: "rgba(255,255,255,0.6)", fontWeight: 400, lineHeight: 1.7, mb: 5, maxWidth: 480, fontSize: { xs: "1rem", md: "1.2rem" } }}>
                            Find accommodation, request services, and manage payments — all in one platform built for students like you.
                        </Typography>
                        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                            <Button
                                onClick={() => navigate("/nav/hostels")}
                                variant="contained"
                                size="large"
                                sx={{
                                    borderRadius: "14px", px: 4, py: 1.8, textTransform: "none", fontWeight: 700, fontSize: "1rem",
                                    background: `linear-gradient(90deg, ${BRAND} 0%, ${BRAND_DARK} 100%)`,
                                    boxShadow: "0 8px 24px rgba(144, 15, 32, 0.4)",
                                    "&:hover": { transform: "translateY(-2px)", boxShadow: "0 12px 32px rgba(144, 15, 32, 0.5)" },
                                    transition: "all 0.3s ease"
                                }}
                            >
                                Explore Hostels
                            </Button>
                            <Button
                                onClick={downloadapp}
                                variant="outlined"
                                size="large"
                                startIcon={<FaGooglePlay />}
                                sx={{
                                    borderRadius: "14px", px: 4, py: 1.8, textTransform: "none", fontWeight: 700, fontSize: "1rem",
                                    borderColor: "rgba(255,255,255,0.25)", color: "white",
                                    "&:hover": { borderColor: "rgba(255,255,255,0.5)", bgcolor: "rgba(255,255,255,0.05)", transform: "translateY(-2px)" },
                                    transition: "all 0.3s ease"
                                }}
                            >
                                Download App
                            </Button>
                        </Box>

                        {/* Stats Row */}
                        <Box sx={{ display: "flex", gap: { xs: 3, md: 5 }, mt: 6, pt: 5, borderTop: "1px solid rgba(255,255,255,0.07)", flexWrap: "wrap" }}>
                            {stats.map((stat, i) => (
                                <Box key={i}>
                                    <Typography variant="h5" sx={{ fontWeight: 900, color: "white" }}>{stat.value}</Typography>
                                    <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.45)", fontWeight: 500 }}>{stat.label}</Typography>
                                </Box>
                            ))}
                        </Box>
                    </Box>

                    {/* Hero Image */}
                    <Box sx={{ flex: 1, display: "flex", justifyContent: "center", alignItems: "center", maxWidth: { md: "45%" } }}>
                        <Box
                            component="img"
                            src={require("./../../assets/landing/home6.png")}
                            sx={{
                                width: "100%", maxWidth: 480, borderRadius: "32px",
                                boxShadow: "0 40px 80px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.05)",
                                transform: "perspective(1000px) rotateY(-5deg)",
                            }}
                        />
                    </Box>
                </Box>
            </Box>

            {/* ═══ FEATURE SECTIONS ═══ */}
            <Box sx={{ px: { xs: 3, md: 8 }, py: { xs: 6, md: 10 } }}>
                {/* Section: Find Services */}
                <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, alignItems: "center", gap: 8, mb: { xs: 8, md: 14 } }}>
                    <Box sx={{ flex: 1 }}>
                        <Box
                            component="img"
                            src={require("./../../assets/landing/home7.png")}
                            sx={{ width: "100%", borderRadius: "28px", boxShadow: "0 24px 60px rgba(0,0,0,0.08)" }}
                        />
                    </Box>
                    <Box sx={{ flex: 1 }}>
                        <Chip label="🛍 Marketplace" size="small" sx={{ bgcolor: "rgba(144, 15, 32, 0.08)", color: BRAND, fontWeight: 700, mb: 3, border: `1px solid rgba(144, 15, 32, 0.15)` }} />
                        <Typography variant="h3" sx={{ fontWeight: 900, color: "#0d0d0d", letterSpacing: "-1px", lineHeight: 1.15, mb: 2.5, fontSize: { xs: "2rem", md: "2.8rem" } }}>
                            Search, Find &<br />Request Services
                        </Typography>
                        <Typography variant="body1" sx={{ color: "text.secondary", fontSize: "1.1rem", lineHeight: 1.8, mb: 4 }}>
                            Discover skilled service providers right on your campus — from tutors and laundry services to repair experts. Browse profiles, review contacts, and make bookings in seconds.
                        </Typography>
                        <Button
                            onClick={() => navigate("/nav/services")}
                            variant="contained"
                            size="large"
                            endIcon={<ArrowForward />}
                            disableElevation
                            sx={{
                                borderRadius: "14px", px: 4, py: 1.8, textTransform: "none", fontWeight: 700,
                                background: `linear-gradient(90deg, ${BRAND} 0%, ${BRAND_DARK} 100%)`,
                                boxShadow: "0 6px 20px rgba(144, 15, 32, 0.2)",
                                "&:hover": { boxShadow: "0 10px 28px rgba(144, 15, 32, 0.3)", transform: "translateY(-2px)" },
                                transition: "all 0.3s ease"
                            }}
                        >
                            Find a Service
                        </Button>
                    </Box>
                </Box>

                {/* Section: Sign Up / Wallet */}
                <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row-reverse" }, alignItems: "center", gap: 8, mb: { xs: 8, md: 14 } }}>
                    <Box sx={{ flex: 1 }}>
                        <Box
                            component="img"
                            src={require("./../../assets/landing/home10.png")}
                            sx={{ width: "100%", borderRadius: "28px", boxShadow: "0 24px 60px rgba(0,0,0,0.08)" }}
                        />
                    </Box>
                    <Box sx={{ flex: 1 }}>
                        <Chip label="💳 EaziWallet" size="small" sx={{ bgcolor: "rgba(144, 15, 32, 0.08)", color: BRAND, fontWeight: 700, mb: 3, border: `1px solid rgba(144, 15, 32, 0.15)` }} />
                        <Typography variant="h3" sx={{ fontWeight: 900, color: "#0d0d0d", letterSpacing: "-1px", lineHeight: 1.15, mb: 2.5, fontSize: { xs: "2rem", md: "2.8rem" } }}>
                            Manage Everything<br />with EaziWallet
                        </Typography>
                        <Typography variant="body1" sx={{ color: "text.secondary", fontSize: "1.1rem", lineHeight: 1.8, mb: 4 }}>
                            Create an account to unlock the full Eazistey experience. Pay for hostel access, manage your balance, and track your spending — all from within the platform.
                        </Typography>
                        <Button
                            onClick={() => setshowloginpopup(true)}
                            variant="contained"
                            size="large"
                            endIcon={<ArrowForward />}
                            disableElevation
                            sx={{
                                borderRadius: "14px", px: 4, py: 1.8, textTransform: "none", fontWeight: 700,
                                background: `linear-gradient(90deg, ${BRAND} 0%, ${BRAND_DARK} 100%)`,
                                boxShadow: "0 6px 20px rgba(144, 15, 32, 0.2)",
                                "&:hover": { boxShadow: "0 10px 28px rgba(144, 15, 32, 0.3)", transform: "translateY(-2px)" },
                                transition: "all 0.3s ease"
                            }}
                        >
                            Create Free Account
                        </Button>
                    </Box>
                </Box>

                {/* Section: Download App */}
                <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, alignItems: "center", gap: 8, mb: { xs: 8, md: 14 } }}>
                    <Box sx={{ flex: 1 }}>
                        <Box
                            component="img"
                            src={require("./../../assets/landing/home4.png")}
                            sx={{ width: "100%", borderRadius: "28px", boxShadow: "0 24px 60px rgba(0,0,0,0.08)" }}
                        />
                    </Box>
                    <Box sx={{ flex: 1 }}>
                        <Chip label="📱 Mobile App" size="small" sx={{ bgcolor: "rgba(144, 15, 32, 0.08)", color: BRAND, fontWeight: 700, mb: 3, border: `1px solid rgba(144, 15, 32, 0.15)` }} />
                        <Typography variant="h3" sx={{ fontWeight: 900, color: "#0d0d0d", letterSpacing: "-1px", lineHeight: 1.15, mb: 2.5, fontSize: { xs: "2rem", md: "2.8rem" } }}>
                            More Power<br />In Your Pocket
                        </Typography>
                        <Typography variant="body1" sx={{ color: "text.secondary", fontSize: "1.1rem", lineHeight: 1.8, mb: 4 }}>
                            Download the Eazistey app to get real-time alerts, instant bookings, and access to exclusive mobile-only features — all optimized for campus life on the go.
                        </Typography>
                        <Button
                            onClick={downloadapp}
                            variant="contained"
                            size="large"
                            startIcon={<FaGooglePlay />}
                            disableElevation
                            sx={{
                                borderRadius: "14px", px: 4, py: 1.8, textTransform: "none", fontWeight: 700,
                                background: "linear-gradient(90deg, #1a1a1a 0%, #333 100%)",
                                "&:hover": { background: "#000", transform: "translateY(-2px)" },
                                transition: "all 0.3s ease"
                            }}
                        >
                            Get it on Google Play
                        </Button>
                    </Box>
                </Box>

                {/* Section: Advertise */}
                <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row-reverse" }, alignItems: "center", gap: 8, mb: { xs: 8, md: 14 } }}>
                    <Box sx={{ flex: 1 }}>
                        <Box
                            component="img"
                            src={require("./../../assets/landing/home1.png")}
                            sx={{ width: "100%", borderRadius: "28px", boxShadow: "0 24px 60px rgba(0,0,0,0.08)" }}
                        />
                    </Box>
                    <Box sx={{ flex: 1 }}>
                        <Chip label="📣 For Landlords & Businesses" size="small" sx={{ bgcolor: "rgba(144, 15, 32, 0.08)", color: BRAND, fontWeight: 700, mb: 3, border: `1px solid rgba(144, 15, 32, 0.15)` }} />
                        <Typography variant="h3" sx={{ fontWeight: 900, color: "#0d0d0d", letterSpacing: "-1px", lineHeight: 1.15, mb: 2.5, fontSize: { xs: "2rem", md: "2.8rem" } }}>
                            Reach Thousands<br />of Campus Students
                        </Typography>
                        <Typography variant="body1" sx={{ color: "text.secondary", fontSize: "1.1rem", lineHeight: 1.8, mb: 4 }}>
                            List your hostel or business on Eazistey and get discovered by students who are actively searching in your area. Setup is fast and completely free.
                        </Typography>
                        <Button
                            onClick={gotomyproperties}
                            variant="contained"
                            size="large"
                            endIcon={<ArrowForward />}
                            disableElevation
                            sx={{
                                borderRadius: "14px", px: 4, py: 1.8, textTransform: "none", fontWeight: 700,
                                background: `linear-gradient(90deg, ${BRAND} 0%, ${BRAND_DARK} 100%)`,
                                boxShadow: "0 6px 20px rgba(144, 15, 32, 0.2)",
                                "&:hover": { boxShadow: "0 10px 28px rgba(144, 15, 32, 0.3)", transform: "translateY(-2px)" },
                                transition: "all 0.3s ease"
                            }}
                        >
                            Add Your Listing
                        </Button>
                    </Box>
                </Box>
            </Box>

            {/* ═══ PRODUCTS GRID ═══ */}
            <Box sx={{ px: { xs: 3, md: 8 }, py: { xs: 6, md: 8 }, bgcolor: "white" }}>
                <Box sx={{ textAlign: "center", mb: 7 }}>
                    <Typography variant="overline" sx={{ color: BRAND, fontWeight: 700, letterSpacing: "2px", fontSize: "0.85rem" }}>WHAT WE OFFER</Typography>
                    <Typography variant="h3" sx={{ fontWeight: 900, color: "#0d0d0d", letterSpacing: "-1px", mt: 1, fontSize: { xs: "2rem", md: "2.8rem" } }}>
                        Our Products & Services
                    </Typography>
                    <Typography variant="body1" sx={{ color: "text.secondary", mt: 2, maxWidth: 500, mx: "auto" }}>
                        Everything a campus student needs, built into one seamless platform.
                    </Typography>
                </Box>

                <Box sx={{ display: "flex", gap: 3, flexWrap: { xs: "wrap", md: "nowrap" } }}>
                    {features.map((feature, i) => (
                        <Paper
                            key={i}
                            elevation={0}
                            onClick={feature.action}
                            sx={{
                                flex: 1, minWidth: { xs: "100%", sm: "45%", md: "30%" }, borderRadius: "24px", overflow: "hidden", cursor: "pointer",
                                border: "1px solid rgba(0,0,0,0.05)", transition: "all 0.4s ease",
                                "&:hover": { transform: "translateY(-8px)", boxShadow: "0 20px 48px rgba(0,0,0,0.08)" }
                            }}
                        >
                            <Box sx={{ height: 200, overflow: "hidden" }}>
                                <Box component="img" src={feature.image} sx={{ width: "100%", height: "100%", objectFit: "cover", transition: "transform 0.5s ease", "&:hover": { transform: "scale(1.04)" } }} />
                            </Box>
                            <Box sx={{ p: 3 }}>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
                                    <Box sx={{ color: BRAND }}>{feature.icon}</Box>
                                    <Typography variant="h6" sx={{ fontWeight: 800, color: "#1a1a1a" }}>{feature.title}</Typography>
                                </Box>
                                <Typography variant="body2" sx={{ color: "text.secondary", lineHeight: 1.7, mb: 3 }}>{feature.description}</Typography>
                                <Button
                                    variant="text"
                                    endIcon={<ArrowForward />}
                                    sx={{ textTransform: "none", fontWeight: 700, color: BRAND, p: 0, "&:hover": { bgcolor: "transparent", textDecoration: "underline" } }}
                                >
                                    {feature.cta}
                                </Button>
                            </Box>
                        </Paper>
                    ))}
                </Box>
            </Box>

            {/* ═══ TESTIMONIALS ═══ */}
            <Box sx={{ px: { xs: 3, md: 8 }, py: { xs: 6, md: 10 }, bgcolor: "#f8f9fa" }}>
                <Box sx={{ textAlign: "center", mb: 7 }}>
                    <Typography variant="overline" sx={{ color: BRAND, fontWeight: 700, letterSpacing: "2px", fontSize: "0.85rem" }}>TESTIMONIALS</Typography>
                    <Typography variant="h3" sx={{ fontWeight: 900, color: "#0d0d0d", letterSpacing: "-1px", mt: 1, fontSize: { xs: "2rem", md: "2.8rem" } }}>
                        What Students Say About Us
                    </Typography>
                </Box>

                <Box sx={{ maxWidth: 1100, mx: "auto", mb: 5 }}>
                    <Swiper
                        slidesPerView={isMobile ? 1 : isTablet ? 2 : 3}
                        spaceBetween={24}
                        loop={false}
                        autoplay={{ delay: 4000, disableOnInteraction: false }}
                        pagination={{ clickable: true }}
                        modules={[Pagination, Autoplay]}
                        style={{ paddingBottom: "48px", "--swiper-pagination-color": BRAND }}
                    >
                        {Array.isArray(testimonialsarray) && testimonialsarray.map((val, key) => (
                            <SwiperSlide key={key}>
                                <Paper
                                    elevation={0}
                                    sx={{
                                        p: 4, borderRadius: "20px", height: "100%", minHeight: 220,
                                        border: "1px solid rgba(0,0,0,0.04)",
                                        boxShadow: "0 4px 20px rgba(0,0,0,0.03)",
                                        display: "flex", flexDirection: "column", justifyContent: "space-between",
                                        transition: "all 0.3s ease",
                                        "&:hover": { boxShadow: "0 12px 40px rgba(0,0,0,0.06)", transform: "translateY(-4px)" }
                                    }}
                                >
                                    {/* Stars */}
                                    <Box sx={{ display: "flex", gap: 0.5, mb: 2 }}>
                                        {[...Array(5)].map((_, i) => <FaStar key={i} color="#f9ca24" size={14} />)}
                                    </Box>
                                    <Typography variant="body1" sx={{ color: "text.secondary", lineHeight: 1.8, fontStyle: "italic", mb: 3, flexGrow: 1 }}>
                                        "{val.review}"
                                    </Typography>
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                                        <Avatar sx={{ width: 40, height: 40, bgcolor: BRAND, fontWeight: 700, fontSize: 16 }}>
                                            {val.name?.charAt(0)?.toUpperCase()}
                                        </Avatar>
                                        <Typography variant="subtitle2" sx={{ fontWeight: 800, color: "#1a1a1a" }}>{val.name}</Typography>
                                    </Box>
                                </Paper>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </Box>

                <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <Button
                        onClick={() => navigate("/nav/contactus")}
                        variant="outlined"
                        size="large"
                        endIcon={<ChatBubbleOutline />}
                        sx={{
                            borderRadius: "14px", px: 5, py: 1.8, textTransform: "none", fontWeight: 700,
                            borderColor: "rgba(144, 15, 32, 0.3)", color: BRAND,
                            "&:hover": { borderColor: BRAND, bgcolor: "rgba(144, 15, 32, 0.04)", transform: "translateY(-2px)" },
                            transition: "all 0.3s ease"
                        }}
                    >
                        Send Us Your Feedback
                    </Button>
                </Box>
            </Box>

            {/* ═══ CTA FOOTER BANNER ═══ */}
            <Box sx={{
                mx: { xs: 3, md: 8 }, mb: { xs: 4, md: 8 }, p: { xs: 5, md: 8 }, borderRadius: "32px",
                background: `linear-gradient(135deg, #0d0d0d 0%, #1a0005 50%, ${BRAND_DARK} 100%)`,
                display: "flex", flexDirection: { xs: "column", md: "row" }, alignItems: "center", justifyContent: "space-between", gap: 4, position: "relative", overflow: "hidden"
            }}>
                <Box sx={{ position: "absolute", width: 400, height: 400, borderRadius: "50%", top: "-50%", right: "-5%", background: `radial-gradient(circle, ${BRAND}44 0%, transparent 70%)`, filter: "blur(40px)" }} />
                <Box sx={{ position: "relative", zIndex: 1 }}>
                    <Typography variant="h4" sx={{ fontWeight: 900, color: "white", letterSpacing: "-0.5px", mb: 1, fontSize: { xs: "1.8rem", md: "2.2rem" } }}>
                        Ready to find your Eazihome?
                    </Typography>
                    <Typography sx={{ color: "rgba(255,255,255,0.55)", fontSize: "1.05rem" }}>
                        Join thousands of students who found their perfect stay.
                    </Typography>
                </Box>
                <Button
                    onClick={() => navigate("/nav/hostels")}
                    variant="contained"
                    size="large"
                    endIcon={<ArrowForward />}
                    sx={{
                        position: "relative", zIndex: 1,
                        borderRadius: "14px", px: 5, py: 2, textTransform: "none", fontWeight: 800, fontSize: "1rem", whiteSpace: "nowrap",
                        background: `linear-gradient(90deg, ${BRAND} 0%, #c0392b 100%)`,
                        boxShadow: "0 8px 24px rgba(0,0,0,0.3)",
                        "&:hover": { transform: "translateY(-2px)", boxShadow: "0 12px 32px rgba(0,0,0,0.4)" },
                        transition: "all 0.3s ease"
                    }}
                >
                    Explore Hostels Now
                </Button>
            </Box>
        </Box>
    );
}

export default Home;